import client from "../Client/HttpClient";
import { IAuthModel } from "@/interfaces/modules";
const ApiPath = "AuthSystemUser";

export default {
  login: (data: IAuthModel): Promise<any> => client.post(`${ApiPath}/Authenticate`, data),
  activateAccount: (data: any): Promise<any> => client.post(`${ApiPath}/ActivateAccount`, data),
  ForgotPassword: (data: any): Promise<any> => client.post(`${ApiPath}/ForgotPassword`, data),
};
